import { PersonNameDTO, ReferencedPersonNameDTO } from '../../api/core';

export const mapPersonNameDtoToReferencedPersonNameDto = (dto: PersonNameDTO): ReferencedPersonNameDTO => {
  if(dto.id === undefined) {
    return null;
  }
  return {...dto, id: dto.id || 0};
};

export const mapPersonNameDtosToReferencedPersonNameDtos = (dtos: PersonNameDTO[]): ReferencedPersonNameDTO[] =>
  dtos
    .map(mapPersonNameDtoToReferencedPersonNameDto)
    .filter(p => p !== null);